import styled, { keyframes } from "styled-components";

export const StyledWrapper = styled.div<{ size?: 'small' | 'default' }>`
    width: ${props => props.size === 'small' ? '24px' : '40px'};
    height: ${props => props.size === 'small' ? '24px' : '40px'};
`

export const StyledRing = styled.div<{ size?: 'small' | 'default' }>`
    display: inline-block;
    position: relative;
    width: ${props => props.size === 'small' ? '20px' : '40px'};
    height: ${props => props.size === 'small' ? '20px' : '40px'};
`


export const rotate = keyframes`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
`   
export const StyledDiv = styled.div<{ size?: 'small' | 'default' }>`
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: ${props => props.size === 'small' ? '16px' : '32px'};
    height: ${props => props.size === 'small' ? '16px' : '32px'};
    margin: ${props => props.size === 'small' ? '2px' : '4px'};
    border: ${props => props.size === 'small' ? '2px' : '4px'} solid ${({theme}) => theme.colors.primary500};
    border-radius: 50%;
    animation: ${rotate} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${({theme}) => theme.colors.primary500} transparent transparent transparent;

    &:nth-child(1) {
    animation-delay: -0.45s;
    }
    &:nth-child(2) {
    animation-delay: -0.3s;
    }
    &:nth-child(3) {
    animation-delay: -0.15s;
    }
`


  